module.exports = __webpack_public_path__ + "img/120x120-1.cfe92532.png";